/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function () {
  function getSelectedOptions(section) {
    var options = {};

    section.querySelectorAll('.ProductForm__Variants--button .ProductForm__Option [type="radio"]:checked').forEach(function (radio) {
      options['option' + radio.getAttribute('data-option-position')] = radio.value;
    });

    return options;
  }

  function findVariant(product, options) {
    return product.variants.find(function (variant) {
      if (variant.option1 !== options.option1) {
        return false;
      }

      if (product.options.length > 1 && variant.option2 !== options.option2) {
        return false;
      }

      if (product.options.length > 2 && variant.option3 !== options.option3) {
        return false;
      }

      return true;
    }) || null;
  }

  function isSizeValueAvailable(product, selectedOptions, sizePosition, value) {
    var testOptions = Object.assign({}, selectedOptions);
    testOptions['option' + sizePosition] = value;

    var variant = findVariant(product, testOptions);
    return !!(variant && variant.available);
  }

  function updateSizeAvailability(section, product) {
    var sizeOption = section.querySelector('.ProductForm__Option[data-option-type="size"]');

    if (!sizeOption) {
      return null;
    }

    var sizePosition = sizeOption.getAttribute('data-option-position');
    var selectedOptions = getSelectedOptions(section);
    var checkedRadio = sizeOption.querySelector('[type="radio"]:checked');

    sizeOption.querySelectorAll('[type="radio"]').forEach(function (radio) {
      var value = radio.value;
      var isAvailable = isSizeValueAvailable(product, selectedOptions, sizePosition, value);
      var label = sizeOption.querySelector('label[for="' + radio.id + '"]');

      radio.disabled = !isAvailable;

      if (label) {
        label.classList.toggle('SizeSwatch--unavailable', !isAvailable);
      }
    });

    if (checkedRadio && checkedRadio.disabled) {
      var firstAvailable = sizeOption.querySelector('[type="radio"]:not([disabled])');

      if (firstAvailable) {
        firstAvailable.checked = true;
        firstAvailable.dispatchEvent(new Event('change', { bubbles: true }));
        return firstAvailable;
      }
    }

    return checkedRadio;
  }

  function updateLowStock(section, inventories, variant) {
    var lowStockElement = section.querySelector('.ProductForm__LowStock');

    if (!lowStockElement) {
      return;
    }

    if (!variant) {
      lowStockElement.style.display = 'none';
      return;
    }

    var inventory = inventories[variant.id];
    var quantity = inventory ? inventory.inventory_quantity : null;
    var hasTrackedInventory = inventory && inventory.inventory_management;
    var shouldShow = hasTrackedInventory && quantity >= 1 && quantity <= 5;

    lowStockElement.style.display = shouldShow ? '' : 'none';
  }

  function updateSelectedLabels(section) {
    section.querySelectorAll('.ProductForm__Variants--button .ProductForm__Option').forEach(function (optionElement) {
      var selectedValueElement = optionElement.querySelector('.ProductForm__SelectedValue');
      var checkedRadio = optionElement.querySelector('[type="radio"]:checked');

      if (selectedValueElement && checkedRadio) {
        selectedValueElement.textContent = checkedRadio.value;
      }
    });
  }

  function initVariantButtonPicker(section) {
    var variantsElement = section.querySelector('.ProductForm__Variants--button');

    if (!variantsElement || variantsElement.getAttribute('data-variant-buttons-init') === 'true') {
      return;
    }

    var productJsonElement = section.querySelector('[data-product-json]');

    if (!productJsonElement) {
      return;
    }

    var data = JSON.parse(productJsonElement.innerHTML);
    var product = data.product;
    var inventories = data.inventories || {};

    function refreshVariantState() {
      updateSelectedLabels(section);
      updateSizeAvailability(section, product);

      var selectedOptions = getSelectedOptions(section);
      var currentVariant = findVariant(product, selectedOptions);

      updateLowStock(section, inventories, currentVariant);
    }

    section.addEventListener('change', function (event) {
      if (!event.target.matches('.ProductForm__Variants--button [type="radio"]')) {
        return;
      }

      refreshVariantState();
    });

    section.addEventListener('variant:changed', function (event) {
      updateLowStock(section, inventories, event.detail.variant);
    });

    variantsElement.setAttribute('data-variant-buttons-init', 'true');
    refreshVariantState();
  }

  function initAllVariantButtonPickers(container) {
    (container || document).querySelectorAll('[data-section-type="product"]').forEach(initVariantButtonPicker);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAllVariantButtonPickers();
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAllVariantButtonPickers(event.target);
  });
})();
